import { Node_Type } from "./../../ricos-types/index.js";
import {
  CollapsibleListItemBodyProperty,
  CollapsibleListItemTitleProperty
} from "./collapsible-item-property.js";
import CollapsibleListItem from "./collapsible-list-item.js";
import CollapsibleList from "./collapsible-list.js";
const nodeViewRenderers = {
  [Node_Type.COLLAPSIBLE_LIST]: CollapsibleList,
  [Node_Type.COLLAPSIBLE_ITEM]: CollapsibleListItem,
  [Node_Type.COLLAPSIBLE_ITEM_TITLE]: CollapsibleListItemTitleProperty,
  [Node_Type.COLLAPSIBLE_ITEM_BODY]: CollapsibleListItemBodyProperty
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
